import { LegalPage } from "@/components/LegalPage";
import { TERMS_SECTIONS } from "@/data/legal";

export default function Terms() {
  return (
    <LegalPage
      testid="terms-page"
      title="Terms of Service"
      intro="These terms govern your use of DeviceLox and any device registration you submit."
      sections={TERMS_SECTIONS}
    />
  );
}
